const initState = {
  userDetailPropertyParams: {},
};

const propertyAnalysis = {
  state: initState,
  mutations: {
    RESET_propertyAnalysis(state) {
      state = Object.assign(state, initState);
    },
    SET_USER_DETAIL_PROPERTY_PARAMS(state, param) {
      state.userDetailPropertyParams = param;
    },
  },
  getters: {},
  actions: {}
};

export default propertyAnalysis;



// WEBPACK FOOTER //
// ./src/store/modules/property-analysis.js